/**
 * People Slider Initialization
 * Initializes all Splide.js people sliders on the page
 */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof Splide !== 'undefined') {
        // Find all slider elements with data-slider-id attribute
        const sliderElements = document.querySelectorAll('.splide[data-slider-id^="people-slider-"]');

        if (sliderElements.length > 0) {
            sliderElements.forEach(function (sliderElement) {
                const sliderId = sliderElement.getAttribute('data-slider-id');

                try {
                    const peopleSlider = new Splide('#' + sliderId, {
                        type: 'loop',
                        start: 0,
                        autoWidth: true,
                        autoplay: true,
                        interval: 4000,
                        pauseOnHover: true,
                        speed: 600,
                        easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                        pagination: false,  // Disable pagination to prevent double rendering
                        breakpoints: {
                            1200: {
                                perPage: 2,
                                gap: '20px',
                            },
                            768: {
                                perPage: 1,
                                gap: '10px',
                            },
                        },
                    });

                    peopleSlider.mount();
                    console.log('People slider initialized successfully: #' + sliderId);
                } catch (error) {
                    console.error('Error initializing slider #' + sliderId + ':', error);
                }
            });

            console.log('Initialized ' + sliderElements.length + ' people slider(s)');
        }
    } else {
        console.error('Splide.js library not loaded');
    }
});
